import { container } from "tsyringe";
/**
 * RentalServices - Represents a connection for rental services from websocket
 */
export default class LoadingServices {
    /**
    * Constructor
    */
    constructor() {
        this.onLoadingShow = (show, dispatch, callback) => {
            const registry = this.application.handle("ShowLoading", (payload) => {
                if (payload !== null && payload !== undefined) {
                    callback(payload);
                    registry.then((solve) => {
                        // solve.unregister();
                    }).catch((err) => console.log("Error to emit event ShowLoading"));
                }
            });
        };
        this.EmitLoadingShow = (show) => {
            const registry = this.application.dispatch("ShowLoading", show);
            registry.then((solve) => {
                // solve.unregister();
            }).catch((err) => console.log("Error to emit event ShowLoading"));
        };
        this.application = container.resolve('IRegisterEventServiceBus');
    }
}
